export function markdownToHtml(markdown) {
  const htmlArray = [];
  const lines = markdown.split('\n');

  for (const line of lines) {
    let currentText = '';
    let prevChar = '';

    for (let i = 0; i < line.length; i++) {
      const char = line[i];

      if (char === '*' && prevChar !== '\\') {
        if (currentText) {
          htmlArray.push(currentText);
          currentText = '';
        }
        const endIndex = line.indexOf('*', i + 1);
        if (endIndex !== -1) {
          const text = line.slice(i + 1, endIndex);
          htmlArray.push(`<em>${text}</em>`);
          i = endIndex;
        }
      } else if (char === '_' && prevChar !== '\\') {
        if (currentText) {
          htmlArray.push(currentText);
          currentText = '';
        }
        const endIndex = line.indexOf('_', i + 1);
        if (endIndex !== -1) {
          const text = line.slice(i + 1, endIndex);
          htmlArray.push(`<em>${text}</em>`);
          i = endIndex;
        }
      } else if (char === '`' && prevChar !== '\\') {
        if (currentText) {
          htmlArray.push(currentText);
          currentText = '';
        }
        const endIndex = line.indexOf('`', i + 1);
        if (endIndex !== -1) {
          const text = line.slice(i + 1, endIndex);
          htmlArray.push(`<code>${text}</code>`);
          i = endIndex;
        }
      } else if (char === '[') {
        if (currentText) {
          htmlArray.push(currentText);
          currentText = '';
        }
        const endIndex = line.indexOf(']', i + 1);
        if (endIndex !== -1) {
          const text = line.slice(i + 1, endIndex);
          const linkStart = line.indexOf('(', endIndex);
          const linkEnd = line.indexOf(')', linkStart + 1);
          if (linkStart !== -1 && linkEnd !== -1) {
            const link = line.slice(linkStart + 1, linkEnd);
            htmlArray.push(`<a href="${link}">${text}</a>`);
            i = linkEnd;
          } else {
            currentText += `[${text}]`;
          }
        }
      } else if (char === '#') {
        if (currentText) {
          htmlArray.push(currentText);
          currentText = '';
        }
        const headerLevel = line.indexOf(' ', i);
        const text = line.slice(headerLevel + 1);
        const level = headerLevel - i;
        htmlArray.push(`<h${level}>${text}</h${level}>`);
        i = line.length;
      } else {
        currentText += char;
      }

      prevChar = char;
    }

    if (currentText) {
      htmlArray.push(currentText);
    }
  }

  return htmlArray;
}

function extractTextWithAsteriskCount(markdown) {
  const regex = /(\*{1,3})(.*?)\1|([^*]+)/g;
  let match;
  const extractedText = [];

  while ((match = regex.exec(markdown)) !== null) {
    if (match[2]) {
      // Text enclosed in asterisks
      extractedText.push({
        text: match[2].trim(),
        tag: match[1], // Capture the asterisks used
      });
    } else {
      // Text not enclosed in asterisks
      extractedText.push({
        text: match[3].trim(),
        tag: '', // No asterisks
      });
    }
  }

  return extractedText.filter((element) => element.text);
}

export function convertToHTML(text) {
  const markdownArray = extractTextWithAsteriskCount(text);
  const htmlArray = [];

  for (const element of markdownArray) {
    let content = '';
    let tag = '';

    switch (element.tag) {
      case '*':
        content = `<em>${element.text}</em>`;
        tag = 'em';
        break;
      case '**':
        content = `<strong>${element.text}</strong>`;
        tag = 'strong';
        break;
      case '***':
        content = `<em><strong>${element.text}</strong></em>`;
        tag = 'em_strong';
        break;
      default:
        content = `<p>${element.text}</p>`;
        tag = 'p';
    }

    htmlArray.push({ content, tag, text: element.text });
  }

  return htmlArray;
}

export function markdownToHTML(markdownText) {
  // Convert italics-bold (***text***)
  let htmlText = markdownText.replace(/\*\*\*(.+?)\*\*\*/g, '<em><strong>$1</strong></em>');

  // Convert bold (**text**)
  htmlText = htmlText.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

  // Convert italics (*text*)
  htmlText = htmlText.replace(/\*(.+?)\*/g, '<em>$1</em>');

  // Convert text enclosed by double quotes ("text")
  // htmlText = htmlText.replace(/"(.+?)"/g, '<cite>$1</cite>');

  return htmlText;
}

export function markdownBasicToHTML(markdownText) {
  // Convert italics-bold (***text***)
  let htmlText = markdownText.replace(/\*\*\*(.+?)\*\*\*/g, '<div><em><strong>$1</strong></em></div>');

  // Convert bold (**text**)
  htmlText = htmlText.replace(/\*\*(.+?)\*\*/g, '<div><strong>$1</strong></div>');

  // Convert italics (*text*)
  htmlText = htmlText.replace(/\*(.+?)\*/g, '<div><em>$1</em></div>');

  // Convert text enclosed by double quotes ("text")
  htmlText = htmlText.replace(/"(.+?)"/g, '<cite>$1</cite>');

  return htmlText;
}

// TODO remove functinos i dont use
export function markdownToHTML2(markdown) {
  const lines = markdown.split('\n\n');
  const result = [];

  for (const line of lines) {
    if (line.startsWith('*') && line.endsWith('*')) {
      // Emphasis
      const text = line.slice(1, -1);
      result.push({ content: `<em>${text}</em>`, tag: 'em', text });
    } else if (line.startsWith('**') && line.endsWith('**')) {
      // Strong emphasis
      const text = line.slice(2, -2);
      result.push({ content: `<strong>${text}</strong>`, tag: 'strong', text });
    } else if (line.startsWith('***') && line.endsWith('***')) {
      // Combined emphasis and strong
      const text = line.slice(3, -3);
      result.push({ content: `<strong><em>${text}</em></strong>`, tag: 'strong em', text });
    } else {
      // Quote (handling quotes within the text)
      const quoteText = line.replace(/"/g, ''); // Remove existing quotes
      result.push({ content: `<q>${quoteText}</q>`, tag: 'q', text: quoteText });
    }
  }

  return result;
}

export function removeEmojisAndSpecialCharacters(text: string): string {
  return removeEmojis(removeSpecialCharacters(text));
}

export function removeEmojis(text: string): string {
  // This regex pattern matches emoji characters
  return text.replace(
    /[\u{1F000}-\u{1F6FF}|\u{1F900}-\u{1F9FF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F1E0}-\u{1F1FF}|\u{1F900}-\u{1F9FF}|\u{1F100}-\u{1F1FF}|\u{1F200}-\u{1F2FF}|\u{2100}-\u{26FF}]/gu,
    '',
  );
}

export function removeAllEmojis(text) {
  // More comprehensive regex that catches:
  // 1. Standard emojis
  // 2. Emoji variations and modifiers
  // 3. Symbol characters
  // 4. Pictographs
  // 5. Emoticons
  // 6. Regional indicators
  // 7. Flags
  return text.replace(
    /[\p{Emoji_Presentation}\p{Extended_Pictographic}\u{1F3FB}-\u{1F3FF}\u{E0020}-\u{E007F}\u{FE00}-\u{FE0F}\u{1F900}-\u{1F9FF}\u{1F1E6}-\u{1F1FF}]/gu,
    '',
  );
}

export function removeSpecialCharacters(inputText: string): string {
  // Remove special characters (*, _, [ and ])
  if (!inputText) {
    return '';
  }
  return inputText.replace(/[*_\[\]]/g, '');
}
